import {
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { WeatherForecast } from './types.ts';

export function Weather() {
  const [forecasts, setForecasts] = useState<WeatherForecast[]>();

  useEffect(() => {
    populateWeatherData();
  }, []);

  const contents =
    forecasts === undefined ? (
      <p>
        <em>
          Loading... Please refresh once the ASP.NET backend has started. See{' '}
          <a href={'https://aka.ms/jspsintegrationreact'}>
            https://aka.ms/jspsintegrationreact
          </a>{' '}
          for more details.
        </em>
      </p>
    ) : (
      <Table aria-labelledby={'tableLabel'}>
        <TableHead>
          <TableRow>
            <TableCell>Date</TableCell>
            <TableCell>Temp. (C)</TableCell>
            <TableCell>Temp. (F)</TableCell>
            <TableCell>Summary</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {forecasts.map((forecast) => (
            <TableRow key={forecast.date}>
              <TableCell>{forecast.date}</TableCell>
              <TableCell>{forecast.temperatureC}</TableCell>
              <TableCell>{forecast.temperatureF}</TableCell>
              <TableCell>{forecast.summary}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    );

  return (
    <Stack direction={'row'} justifyContent={'center'}>
      <Paper elevation={10} style={{ padding: 16 }}>
        <Typography variant={'h1'} id={'tableLabel'} textAlign={'center'}>
          Weather forecast
        </Typography>
        <Typography variant={'body1'} textAlign={'center'}>
          This component demonstrates fetching data from the server.
        </Typography>
        {contents}
      </Paper>
    </Stack>
  );

  function populateWeatherData() {
    fetch(import.meta.env.VITE_BASE_API_URL + '/api/weatherforecast/', {
      // credentials: 'same-origin',
      credentials: 'include',
      method: 'GET',
    })
      .then((r) => {
        if (r.ok) {
          return r.json();
        }
        throw Error('Unable to process response, is backend running?');
      })
      .then((data: WeatherForecast[]) => {
        setForecasts(data);
      })
      .catch((e) => {
        console.error(e);
      });
  }
}
